import { render } from "./SubmitClaimRequest.vue?vue&type=template&id=7a814f52"
import script from "./SubmitClaimRequest.vue?vue&type=script&lang=js"
export * from "./SubmitClaimRequest.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__